import { parseNumber } from '@utils/numberConversions'

export const buildRiskProduct = (riskProduct, riskProductType) => {
  const date = new Date()
  const builtRiskProduct = {
    product_type: riskProductType,
    name: riskProduct.name,
    created_at: date,
    value: parseNumber(riskProduct.value) || 0,
    monthly_contribution: parseNumber(riskProduct.monthly_contribution) || 0,
    contract_number: riskProduct.contract_number,
    service_provider_id: riskProduct.service_provider_id,
    owners: riskProduct.owners || [],
    payers: riskProduct.payers || [],
    beneficiaries: riskProduct.beneficiaries || [],
  }

  return builtRiskProduct
}
